var _style, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackIndLogoHoriz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 130",
    style: {
      enableBackground: "new 0 0 1000 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stBILH{fill:#010101;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M71.8,14.4l2.9-3.8c0.5-0.6,0.9-1.3,1.5-1.9C75.6,7.4,75,5.9,74,4.2c-2-0.5-3.5-0.7-5.1-0.9 c-0.4,0.7-1,1.3-1.4,1.9L64.6,9l-2.9,3.8l-1.3,1.7c3.1,0.4,6.1,1.5,8.9,3.3L71.8,14.4z M99.6,68.7c-4.4-9.5-14-17.4-18.9-19.2 C80,29.4,68.1,21.9,56.6,21.9h-2.4h-2.4c-11.5,0-23.3,7.5-24.1,27.7C22.9,51.4,13.3,60,8.8,69.5c-5.2,11.1-3.4,34.5-3.2,36.8 l0.4,6.3h15.8c11.6,0,15.2-11.6,16.3-20c3.5,7,9.1,17.7,14.1,28.7l2,4.1l2-4.6c5-10.9,10.6-21,14.1-28.1 c1.1,8.4,4.7,19.9,16.3,19.9h15.8l0.4-6.6C103,103.6,104.8,79.9,99.6,68.7z M29.3,81.3L29.3,81.3c0,12.7-2.2,19.9-7.4,19.9H15 c-0.3-7.9-0.2-20.5,2.6-26.4c2.1-4.5,5.4-9.7,8.2-12.4l2.3,12.9L29.3,81.3C29.3,81.3,29.3,81.3,29.3,81.3z M51.8,32.1h2.4h2.4 c6.6,0,13.3,3.4,14.7,15.9H54.3H37.1C38.6,35.5,45.2,32.1,51.8,32.1z M54.2,103c-2.2-5.3-5.2-9.8-7.3-14.3h14.7 C59.4,93.3,56.4,97.8,54.2,103z M71.4,61.5c-0.4,3.4-1.2,10.2-1.9,13.6H39c-0.7-3.4-1.5-10.2-1.9-13.6 M93.5,101.2h-6.8 c-5.2,0-7.4-7.2-7.4-19.9v0c0,0,0,0,0,0l1.2-6.3l2.3-12.7c2.8,2.7,6.1,7.9,8.2,12.5C93.7,80.8,93.8,93.3,93.5,101.2z M36.7,14.4 l2.5,3.2c2.8-1.8,5.8-2.9,8.9-3.3l-1.3-1.7L43.8,9l-2.9-3.8c-0.5-0.6-1-1.2-1.4-1.9c-1.5,0.2-3.1,0.4-5.1,0.9 c-1,1.8-1.6,3.2-2.2,4.7c0.6,0.6,1,1.2,1.5,1.9L36.7,14.4z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M152.2,29.8h17.9v68.7h-17.9V29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M226,71.9c-5.1-4.5-9.9-10.3-9.9-10.3s1.3,8.8,1.3,14.5v22.4h-16.5V28.9h1.4l31.7,27.4 c5.5,4.9,9.9,10.4,9.9,10.4s-1.1-8.9-1.1-14.6V29.8h16.5v69.7h-1.4L226,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M289.9,29.8h24.7c20.3,0,35.8,13.2,35.8,34.3c0,20.9-15.4,34.3-35.8,34.3h-24.7V29.8z M313.8,83 c12.8,0,18.4-7.2,18.4-18.8c0-11.4-5.7-18.8-18.4-18.8h-5.9V83H313.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M378.9,71.4V29.8h17.9v41.3c0,8.4,3.7,12.6,11.7,12.6c8,0,11.7-4.1,11.7-12.6V29.8h17.9v41.6 c0,18.6-12.4,28.3-29.5,28.3C391,99.7,378.9,89.9,378.9,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M462.6,83.8l14-8.2c2.9,5,7.2,8.9,14.3,8.9c4.9,0,8.4-1.8,8.4-5c0-3.3-2.5-4.7-9.3-7.5l-2.9-1.2 c-11.3-4.6-19-10.1-19-22.4c0-12,9.2-19.9,22.5-19.9c9.9,0,16.7,2.9,22.4,11.8l-13.6,7.8c-2.4-3.8-4.9-4.9-8.3-4.9 c-3.6,0-5.9,1.8-5.9,4.9c0,3.7,3,5,7.1,6.7l2.9,1.2c12.6,5.1,21.8,10.3,21.8,23.3c0,12.8-9.7,20.3-25.9,20.3 C477.2,99.7,467.1,93,462.6,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M558.1,45.3h-19.5V29.8h57v15.5h-19.5v53.2h-18V45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M679.3,98.5h-20.1l-9.6-16.6c-0.9,0.1-1.8,0.1-2.8,0.1h-5.4v16.4h-17.9V29.8h23.3c18.2,0,31.5,8.2,31.5,26.3 c0,10.3-4.7,17.1-12.1,20.9L679.3,98.5z M646.4,66.9c9.3,0,13.6-3,13.6-10.8c0-7.8-4.2-10.9-13.6-10.9h-5v21.7H646.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M707.6,29.8h17.9v68.7h-17.9V29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M754.6,64.1c0-21.1,16.8-35.5,37-35.5c20.1,0,37,14.5,37,35.5c0,20.8-16.8,35.5-37,35.5 C771.4,99.7,754.6,84.9,754.6,64.1z M810.3,64.1c0-11.6-7.6-19.7-18.7-19.7s-18.7,8.2-18.7,19.7c0,11.8,7.6,19.7,18.7,19.7 S810.3,76,810.3,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M857,71.4V29.8h17.9v41.3c0,8.4,3.7,12.6,11.7,12.6c8,0,11.7-4.1,11.7-12.6V29.8h17.9v41.6 c0,18.6-12.4,28.3-29.5,28.3C869.1,99.7,857,89.9,857,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stBILH",
    d: "M940.7,83.8l14-8.2c2.9,5,7.2,8.9,14.3,8.9c4.9,0,8.4-1.8,8.4-5c0-3.3-2.5-4.7-9.3-7.5l-2.9-1.2 c-11.3-4.6-19-10.1-19-22.4c0-12,9.2-19.9,22.5-19.9c9.9,0,16.7,2.9,22.4,11.8l-13.6,7.8c-2.4-3.8-4.9-4.9-8.3-4.9 c-3.6,0-5.9,1.8-5.9,4.9c0,3.7,3,5,7.1,6.7l2.9,1.2c12.6,5.1,21.8,10.3,21.8,23.3c0,12.8-9.7,20.3-25.9,20.3 C955.3,99.7,945.2,93,940.7,83.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackIndLogoHoriz);
export default __webpack_public_path__ + "static/media/BlackIndLogoHoriz.81283588dbc505a3cebf6a54be1a29c4.svg";
export { ForwardRef as ReactComponent };